import React from 'react';
import { UserPlus } from 'lucide-react';
export function OnboardingStatusWidget() {
  // Mock data
  const onboardingData = [{
    id: 1,
    employee: 'Thomas Petit',
    startDate: '15 nov. 2023',
    progress: 30,
    status: 'in-progress'
  }, {
    id: 2,
    employee: 'Camille Roux',
    startDate: '1 déc. 2023',
    progress: 0,
    status: 'upcoming'
  }];
  return <div className="bg-white rounded-lg shadow-sm p-5" data-id="element-2009">
      <div className="flex items-center justify-between mb-4" data-id="element-2010">
        <h3 className="font-semibold text-gray-900" data-id="element-2011">Onboarding</h3>
        <UserPlus className="h-5 w-5 text-blue-600" data-id="element-2012" />
      </div>
      <div className="space-y-4" data-id="element-2013">
        {onboardingData.map(item => <div key={item.id} className="border border-gray-200 rounded-lg p-3" data-id="element-2014">
            <div className="flex justify-between items-start mb-2" data-id="element-2015">
              <div data-id="element-2016">
                <p className="font-medium text-gray-900" data-id="element-2017">{item.employee}</p>
                <p className="text-xs text-gray-600" data-id="element-2018">Début: {item.startDate}</p>
              </div>
              <span className={`text-xs px-2 py-1 rounded-full ${item.status === 'in-progress' ? 'bg-blue-100 text-blue-800' : 'bg-gray-100 text-gray-800'}`} data-id="element-2019">
                {item.status === 'in-progress' ? 'En cours' : 'À venir'}
              </span>
            </div>
            {item.status === 'in-progress' && <div data-id="element-2020">
                <div className="w-full bg-gray-200 rounded-full h-2 mb-1" data-id="element-2021">
                  <div className="bg-blue-600 h-2 rounded-full" style={{
              width: `${item.progress}%`
            }} data-id="element-2022"></div>
                </div>
                <div className="text-xs text-gray-600 text-right" data-id="element-2023">
                  {item.progress}% complété
                </div>
              </div>}
          </div>)}
      </div>
      <button className="mt-4 w-full py-2 px-4 border border-gray-300 hover:bg-gray-50 rounded-md text-sm font-medium text-gray-700 transition-colors duration-150 ease-in-out" data-id="element-2024">
        Voir tous les onboardings
      </button>
    </div>;
}